/* globals axios, Swiper */
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
import Vue from 'vue';

Vue.component('home-highlighted-products-slider', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiper: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.swiper) {
            this.destroySwiper();
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        handleResize() {
            if (window.innerWidth < 760) {
                // Initialize if not already created.
                if (!this.swiper) {
                    this.loadSwiper();
                }
            } else if (this.swiper && window.innerWidth >= 760) {
                this.destroySwiper();
            }
        },
        loadSwiper() {
            this.swiper = new Swiper(this.$el, {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 10,
                loop: false,
            });
        },

        destroySwiper() {
            this.swiper.destroy();
            this.swiper = null;
        },
    },
});
